<script setup lang="ts">
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
</script>

<template>
    <div class="empty-state" data-cy="text-diffs_empty-state">
        <i class="pi pi-info-circle empty-icon" data-cy="text-diffs_empty-icon"></i>
        <h3 data-cy="text-diffs_empty-title">{{ t('textDiffs.noData') }}</h3>
        <p data-cy="text-diffs_empty-description">{{ t('textDiffs.noDataDescription') }}</p>
    </div>
</template>

<style scoped>
.empty-state {
    text-align: center;
    padding: 3rem 1rem;
    margin-top: 1.5rem;
    color: var(--p-text-muted-color);
}

.empty-state i {
    font-size: 3rem;
    margin-bottom: 1rem;
    opacity: 0.5;
}

.empty-state h3 {
    margin: 1rem 0 0.5rem 0;
    font-weight: 600;
    color: var(--p-text-color);
}

.empty-state p {
    margin: 0;
    font-size: 0.875rem;
}
</style>
